import { useMutation, useQuery } from "@tanstack/react-query";
import { apiClient } from "./api-client";

export function useGetWorkerPrice() {
  return useMutation({
    mutationFn: () => apiClient({ url: "admin/price", method: "GET" })
  });
}

export function useGetClientPrice() {
  return useMutation({
    mutationFn: () => apiClient({ url: "admin/client-price", method: "GET" })
  });
}

export function useUpdateWOrkerPrice() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({ url: "admin/price/" + payload.id, method: "PATCH", data: payload })
  });
}

export function useGetAdminConfiguration() {
  return useMutation({
    mutationFn: () => apiClient({ url: "admin-configuration", method: "GET" }),
  });
}

export function useUpdateAdminConfiguration() {
  return useMutation({
    mutationFn: (data) =>
      apiClient({ url: "admin-configuration", method: "PATCH", data }),
  });
}

export function useGetUserPrice() {
  return useMutation({
    mutationFn: () => apiClient({ url: "users/price", method: "GET" })
  });
}

/** GET users/admin-config/uplifts — uplift + on-cost percentages:
 * { weekendUplift, nightUplift, urgentUplift, bankHolidayUplift,
 *   holidayPay, ni, levy, pension }
 */
export function useGetAdminConfigUplifts() {
  return useQuery({
    queryKey: ["users", "admin-config", "uplifts"],
    queryFn: () => apiClient({ url: "users/admin-config/uplifts", method: "GET" }),
  });
}